module.exports = __webpack_public_path__ + "img/top_option-1.43c1c835.png";